export default "__VITE_ASSET__DfbM2Z9K__"